import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["field", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form'; // Utils

import { validateField } from '../../validation/validationUtil';

var FinalField = function FinalField(props) {
  var field = props.field,
      children = props.children,
      finalFieldProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Field, _extends({
    name: field.name,
    validate: validateField(field),
    type: field.type
  }, finalFieldProps), function (_ref) {
    var input = _ref.input,
        meta = _ref.meta;
    // Prioritise on showing submission errors if it exist and
    // the form has not been modified after last submit
    var error = meta.submitError && !meta.modifiedSinceLastSubmit ? meta.submitError : meta.error; // `display` contains form information that has been processed for form display purposes

    var display = {
      error: meta.touched ? error : undefined
    };
    return children({
      input: _objectSpread(_objectSpread({}, input), {}, {
        type: field.type,
        maxLength: field.maxLength
      }),
      meta: meta,
      display: display
    });
  });
};

FinalField.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired
};
export default FinalField;